export const ns = 'cube3/resource-edges' as const;
